import { ComposableMap, Geographies, Geography, Marker } from 'react-simple-maps';
import { motion } from 'framer-motion';
import geoData from '@/data/countries-110m.json';

/**
 * Real world map using topojson country geometry from react-simple-maps.
 * Continents filled with Navy/Teal theme + animated Teal office markers.
 */

// Office coordinates [longitude, latitude]
const OFFICES = [
  { name: 'Netherlands', coords: [ 4.9,  52.3],  anchor: 'start', dx: 12,  dy: -10 },
  { name: 'India',       coords: [73.8,  19.5],  anchor: 'start', dx: 12,  dy: 4 },
];

export const WorldMap = () => {
  return (
    <div className="relative w-full" data-testid="world-map">
      <ComposableMap
        projection="geoEqualEarth"
        projectionConfig={{ scale: 165, center: [10, 15] }}
        width={980}
        height={460}
        style={{ width: '100%', height: 'auto' }}
      >
        <Geographies geography={geoData}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill="#E2E8F0"
                stroke="#FFFFFF"
                strokeWidth={0.6}
                style={{
                  default: { fill: '#E2E8F0', outline: 'none' },
                  hover:   { fill: '#1B5E5A', outline: 'none', transition: 'fill 0.3s' },
                  pressed: { fill: '#1B5E5A', outline: 'none' },
                }}
              />
            ))
          }
        </Geographies>

        {OFFICES.map((office, i) => (
          <Marker key={office.name} coordinates={office.coords}>
            {/* Outer pulse ring */}
            <motion.circle
              r={5}
              fill="none"
              stroke="#1B5E5A"
              strokeWidth={1.5}
              initial={{ scale: 1, opacity: 0.85 }}
              animate={{ scale: 3.5, opacity: 0 }}
              transition={{ duration: 2.2, repeat: Infinity, delay: i * 0.35, ease: 'easeOut' }}
            />
            {/* Solid marker */}
            <circle r={5} fill="#1B5E5A" stroke="#FFFFFF" strokeWidth={1.5} />
            <circle r={1.8} fill="#FFFFFF" />

            {/* Label pill */}
            <g transform={`translate(${office.dx}, ${office.dy})`}>
              <rect
                x={office.anchor === 'end' ? -64 : 0}
                y={-10}
                width={64}
                height={18}
                rx={9}
                fill="#0D1B2A"
              />
              <text
                x={office.anchor === 'end' ? -32 : 32}
                y={2.5}
                textAnchor="middle"
                fontSize={10}
                fontWeight={600}
                fill="#FFFFFF"
                fontFamily="Inter, sans-serif"
                style={{ pointerEvents: 'none' }}
              >
                {office.name}
              </text>
            </g>
          </Marker>
        ))}
      </ComposableMap>
    </div>
  );
};

export default WorldMap;
